<style lang="less">
@import './unlock.less';
</style>

<template>
    <transition name="show-unlock">
        <div class="unlock-body-con" v-if="showUnlock" @keydown.enter="handleUnlock">
            <div @click="handleClickAvator" class="unlock-avator-con" :style="{marginLeft: avatorLeft}">
                <img class="unlock-avator-img" :src="avatorPath">
                <div class="unlock-avator-cover">
                    <span>
                        <Icon type="md-unlock" :size="30"></Icon>
                    </span>
                    <p>{{t.unLock}}</p>
                </div>
            </div>
            <div class="unlock-avator-under-back" :style="{marginLeft: avatorLeft}"></div>
            <div class="unlock-input-con">
                <div class="unlock-input-overflow-con">
                    <div class="unlock-overflow-body" :style="{right: inputLeft}">
                        <input ref="inputEle" v-model="password" class="unlock-input" type="password"
                               :placeholder="t.passwordPlaceholder"/>
                        <button ref="unlockBtn" @mousedown="unlockMousedown" @mouseup="unlockMouseup"
                                @click="handleUnlock" class="unlock-btn">
                            <Icon color="white" type="md-key" :size="30"></Icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="unlock-locking-tip-con">{{t.locked}}</div>
        </div>
    </transition>
</template>

<script>
import { add } from '@/api/dept';
import { validatePassword } from '@/api/app';
import store from '@/store';
import CryptoJS from 'crypto-js';

export default {
    name: 'Unlock',
    data() {
        const t = this.$_t();
        return {
            t: t,
            avatorLeft: '0px',
            inputLeft: '400px',
            password: '',
            check: null,
            showUnlock: false,
        };
    },
    props: {
        avatorPath: String,
    },
    methods: {
        handleClickAvator() {
            this.avatorLeft = '-180px';
            this.inputLeft = '0px';
            this.$refs.inputEle.focus();
        },
        async handleUnlock() {
            await validatePassword({
                loginName: store.state.user.myInfo.loginName,
                password: CryptoJS.MD5(this.password + store.state.user.myInfo.salt)
                    .toString()
                    .toUpperCase(),
            });
            this.avatorLeft = '0px';
            this.inputLeft = '400px';
            this.password = '';
            this.showUnlock = false;
            this.$emit('on-unlock');
        },
        unlockMousedown() {
            this.$refs.unlockBtn.className = 'unlock-btn click-unlock-btn';
        },
        unlockMouseup() {
            this.$refs.unlockBtn.className = 'unlock-btn';
        },
    },
    mounted() {
        this.showUnlock = true;
    },
};
</script>
